import * as React from "react";
import { createUseStyles } from "react-jss";
import Divider from "@warda/library-ui/core/Divider";
import List from "@warda/library-ui/core/List";
import Popover from "@warda/library-ui/core/Popover";
import { ACTION } from "./reducer";
import WindowPlaceholder from "./WindowPlaceholder";
import Card from "./Card";
import WindowJobsToolbar from "./WindowToolbar";
const originAnchor = {
    vertical: "bottom",
    horizontal: "right",
};
const originTransf = {
    vertical: "top",
    horizontal: "right",
};
const width = 400;
const useStyles = createUseStyles({
    window: {
        maxHeight: "90vh",
        width,
        minWidth: width,
        maxWidth: width,
        minHeight: 168,
        display: "flex",
        flexDirection: "column",
    },
    windowList: {
        flex: 1,
        overflowY: "overlay",
    },
});
const WindowJobs = ({ dispatch, open, anchorEl, title, items, }) => {
    const classes = useStyles({});
    const onClose = React.useCallback(() => {
        dispatch({ type: ACTION.WINDOW_OPEN, open: false });
    }, [dispatch]);
    return (React.createElement(Popover, { open: open, onClose: onClose, anchorEl: anchorEl, originAnchor: originAnchor, originTransf: originTransf, className: classes.window },
        React.createElement(WindowJobsToolbar, { dispatch: dispatch, title: title, actions: !!items.length }),
        React.createElement(Divider, null),
        !items.length ? (React.createElement(WindowPlaceholder, null)) : (React.createElement(List, { className: classes.windowList }, items.map((d) => (React.createElement(Card, { key: d.jobId, dispatch: dispatch, data: d })))))));
};
export default WindowJobs;
